import { supabase } from "../supabaseClient";

export async function fetchPendingApprovalProviders() {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/api/Provider/pending`
    );

    if (!response.ok) {
      throw new Error(`Erreur HTTP ! statut : ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    if (error.name === "AbortError") {
      console.log("Requête annulée");
      return null; // Requête annulée proprement
    }
    console.error("Erreur lors de la récupération du fournisseur :", error);
    throw error; // Renvoyer l'erreur pour un traitement ultérieur
  }
}

// Récupérer les fournisseurs avec un statut différent de "pending"
export async function fetchProviders() {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/api/Provider`
    );

    if (!response.ok) {
      throw new Error(`Erreur HTTP ! statut : ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    if (error.name === "AbortError") {
      console.log("Requête annulée");
      return null; // Requête annulée proprement
    }
    console.error("Erreur lors de la récupération du fournisseur :", error);
    throw error; // Renvoyer l'erreur pour un traitement ultérieur
  }
}

export async function fetchProviderById(id, signal) {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/api/Provider/${id}`,
      { signal }
    );

    if (!response.ok) {
      throw new Error(`Erreur HTTP ! statut : ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    if (error.name === "AbortError") {
      console.log("Requête annulée");
      return null; // Requête annulée proprement
    }
    console.error("Erreur lors de la récupération du fournisseur :", error);
    throw error; // Renvoyer l'erreur pour un traitement ultérieur
  }
}

export async function updateProvider(provider, signal) {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/api/Provider`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(provider),
        signal,
      }
    );

    if (!response.ok) {
      throw new Error(`Erreur HTTP ! statut : ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    if (error.name === "AbortError") {
      return null; // Requête annulée proprement
    }
    console.error("Erreur lors de la mise à jour du fournisseur :", error);
    throw error;
  }
}

export async function fetchAllProviders(signal) {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/api/Provider`,
      { signal }
    );

    if (!response.ok) {
      throw new Error(`Erreur HTTP ! statut : ${response.status}`);
    }

    console.log("Requête réussie pour tous les fournisseurs");
    return await response.json();
  } catch (error) {
    if (error.name === "AbortError") {
      console.log("Requête annulée");
      return [];
    }
    console.error("Erreur lors de la récupération des fournisseurs :", error);
    throw error;
  }
}
